<template>
  <div>
    <div v-if="!hideLocation" class="row main-row">
      <div class="col-md-3">
        <h4 class="text-right">Location</h4>
      </div>
      <div class="col-md-9">
        <p class="padding-top" v-if="getAddress || getAddressTwo">{{ getAddress }} {{ getAddressTwo }}</p>
        <p class="padding-top" v-if="getCity || getState || getZip">{{ getCity }} {{ getState }} {{ getZip }}</p>
      </div>
    </div>
    <div class="row main-row" v-if="getTimes">
      <div class="col-md-3">
        <h4 class="text-right">Hours</h4>
      </div>
      <div class="col-md-9">
        <div v-for="(time, day) in getTimes" :key="time.id" class="row">
          <div class="col-4">
            <p class="padding-top">{{ capitalize(day) }}</p>
          </div>
          <div v-if="time.open"  v-bind:class="{'col-4': time.closed, 'col-8': !time.closed}">
            <p class="padding-top">{{ time.open }}</p>
          </div>
          <div v-if="!time.open"  v-bind:class="{'col-4': time.closed, 'col-8': !time.closed}">
            <p class="padding-top">Closed</p>
          </div>
          <div v-if="time.closed" class="col-4">
            <p class="padding-top">{{ time.closed }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getSelectedServices">
      <hr>
      <div class="row main-row">
        <div class="col">
          <h4>Services & Specialties</h4>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div v-for="service in getSelectedServices" :key="service.id" class="col-md-4">
            <h5>{{ service }}</h5>
            <div v-for="specialty in selectedSpecialties" :key="specialty.id" v-if="hasAdvertisingPlan">
              <div class="row">
                <div class="col">
                  <p v-if="specialties[service].includes(specialty)" class="padding-top">{{ specialty }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr v-if="getCompanyInfo || getCompanyInfoTwo">
    <div class="row main-row" v-if="getYearsInService && !hideYears">
      <div class="col-md-3">
        <h4 class="text-right">Est:</h4>
      </div>
      <div class="col-md-9">
        <p>{{ getYearsInService }}</p>
      </div>
    </div>
    <div class="row main-row" v-if="getCompanyInfo">
      <div class="col-md-3">
        <h4 class="text-right">Who we are:</h4>
      </div>
      <div class="col-md-9">
        <p>{{ getCompanyInfoTwo }}</p>
      </div>
    </div>
    <div class="row main-row" v-if="getCompanyInfoTwo">
      <div class="col-md-3">
        <h4 class="text-right">What we provide:</h4>
      </div>
      <div class="col-md-9">
        <p>{{ getCompanyInfo }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    capitalize (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  },
  props: {
    'getAddress': String,
    'getAddressTwo': String,
    'getCity': String,
    'getState': String,
    'getZip': String,
    'getTimes': Object,
    'getCompanyInfo': String,
    'getCompanyInfoTwo': String,
    'getSelectedServices': Array,
    'getYearsInService': String,
    'hideYears': Boolean,
    'hideLocation': Boolean,
    'selectedSpecialties': Array,
    'specialties': Array,
    'hasAdvertisingPlan': Boolean
  }
}
</script>

<style scoped>
hr {
  border-width: 2px;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
  }

  .main-row {
    margin-bottom: 1rem;
  }
}

.padding-top {
  margin-top: 1px;
  margin-bottom: .4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/business/subnavItems/Information.vue